import { VAR_REG_EXP_GLOBALLY } from 'shared/entities/regExp/var';

/**
 * wraps the text %variable% in a span tag, replacing the space in data-id with &nbsp;
 */
export const wrapVars = (text: string): string => {
  return text.replace(VAR_REG_EXP_GLOBALLY, (match) => {
    // заменяем пробелы и кавычки в переменной на спец символы, чтобы data-id корректно работало
    return `<span data-type="mention" data-id="${match
      .replace(/ /g, '&nbsp;')
      .replace(/"/g, '&#34;')}">${match}</span>`;
  });
};
